import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getDataComponentes = () => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        }
    };

    return fetch(`${url}/unoauno/componentes/getDataComponentes`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateStateComponente = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/componentes/updateStateComponente`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateStateImagen = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/componentes/updateStateImagen`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deleteImagenComponente = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/componentes/deleteImagenComponente`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateImagenComponente = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/componentes/updateImagenComponente`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImagenComponente = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/componentes/saveImagenComponente`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImagen = ({file, idImg, extension, nombreImg}) => {
    const formData = new FormData();

    formData.append('id', idImg.toString());
    formData.append('extension', extension);
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/componentes/saveImagen`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const componentesService = {
    getDataComponentes,
    updateStateComponente,
    updateStateImagen,
    deleteImagenComponente,
    updateImagenComponente,
    saveImagenComponente,
    saveImagen
};